import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 30vh;
  max-width: 20vw;
  background: ${colors.WHITE};
  border-radius: 1rem 1rem 0 0;
  cursor: pointer;
  flex: 1 0 20vw;
`;

export const ThumbnailContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 55%;
  background: ${colors.GRAY};
  width: 100%;
  border-radius: 1rem 1rem 0 0;
  position: relative;
  justify-content: center;
  align-items: center;
`;

export const ProgressContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

export const LessonInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 45%;
  width: 100%;
  justify-content: space-between;
  padding: 1rem 0.5rem;
  font-family: var(--app-font);
  font-weight: bold;
  font-size: 1.25rem;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const LessonTypeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
`;

export const thumbnailImage = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '1rem 1rem 0 0',
};

export const noImageIcon = {
  fontSize: '3rem',
  color: colors.GRAY_DARK,
};

export const lessonTitle = {
  fontSize: '1vmax',
  fontWeight: 'bold',
};

export const lessonType = {
  fontSize: '2vmin',
  fontWeight: 'bold',
};

export const videoIcon = {
  color: colors.GREEN_SHINING_ULTRA,
  fontSize: '2vmin',
};

export default {
  CardContainer,
  ThumbnailContainer,
  ProgressContainer,
  LessonInfo,
  LessonTypeContainer,
  lessonTitle,
  lessonType,
  thumbnailImage,
  noImageIcon,
  videoIcon,
};
